import React, {
  Component
} from 'react';
import moment from 'moment';
import {
  css
}
  from 'emotion';
import {
  Card,
  Button,
  Alert
}
  from "@maxmilhas/hangar-components-atomic/public";
import {
  gridGutter,
}
  from "@maxmilhas/hangar-components-atomic/public/styles/components/quarks/layout";
import {
  blue,
  grayFont,
  basicBlack
} from "@maxmilhas/hangar-components-atomic/public/styles/components/quarks/colors";
import BankModalData from './BankModalData';
import PasswordModal from './PasswordModal';
import CancellationModal from '../CancellationModal';
import Summary from "./Summary";
import SummaryItem from "../molecules/SummaryItem";
import {
  $,
  convertToReal,
  getFlightsList,
  getPassengerList
}
  from "../../../../shared/utils";
import {
  cancelOrder,
} from "../../../../shared/requests-api";

// const h1TitlePadding = `
//     padding-top: ${gridGutter}px;
// `;

export default class CancellationBillingResume extends Component {
  constructor() {
    super();
    this.state = {
      bankDataModalOpen: false,
      confirmPasswordModalOpen: false,
      messageModalOpen: false,
      messageScenario: null,
      bankData: null,
      infoData: {
        typeCancel: "totalCancel"
      }
    };

    this.toggleMessageModal = this.toggleMessageModal.bind(this);
    this.togglePasswordModal = this.togglePasswordModal.bind(this);
    this.toggleBankDataModal = this.toggleBankDataModal.bind(this);
    this.getConfirmationModal = this.getConfirmationModal.bind(this);
    this.bankModalSubmit = this.bankModalSubmit.bind(this);
    this.submit = this.submit.bind(this);
  }

  toggleMessageModal(scenario) {
    const {
      messageModalOpen
    } = this.state;
    $("body").classList.remove("body-lock");
    if (!messageModalOpen) {
      $("body").classList.add("body-lock");
    }
    this.setState({
      messageModalOpen: !messageModalOpen,
      messageScenario: {
        type: scenario
      }
    });
  }

  togglePasswordModal() {
    const { confirmPasswordModalOpen } = this.state;
    $("body").classList.remove("body-lock");
    if (!confirmPasswordModalOpen) {
      $("body").classList.add("body-lock");
    }
    this.setState({
      confirmPasswordModalOpen: !confirmPasswordModalOpen
    });
  }

  toggleBankDataModal() {
    const {
      bankDataModalOpen
    } = this.state;
    $("body").classList.remove("body-lock");
    if (!bankDataModalOpen) {
      $("body").classList.add("body-lock");
    }
    this.setState({
      bankDataModalOpen: !bankDataModalOpen
    });
  }

  submit(data) {
    const { infoData, bankData } = this.state;
    const submitData = data;
    submitData.infoData = infoData;
    submitData.bankData = bankData;
    cancelOrder(
      submitData.loginToken,
      submitData.token,
      submitData.orderCode,
      submitData.bankData,
      submitData.infoData
    ).then(response => {
      this.togglePasswordModal();
      this.toggleMessageModal("Success");
    }).catch(err => {
      if (err.response.data.type == "InvalidChargeBackValueException") {
        this.togglePasswordModal();
        this.toggleMessageModal("InvalidChargeBackValueException");
      } else {
        this.toggleMessageModal("GenericException");
      }
    });
  }

  bankModalSubmit(bankData) {
    this.setState({
      bankData: bankData
    });

    this.toggleBankDataModal();
    this.togglePasswordModal();
  }

  getConfirmationModal() {
    const order = this.props.order;
    const flights = getFlightsList(order.flights);
    let flight = [];
    flights.forEach(flightItem => flight.push(flightItem.flightNumber));
    const passengers = getPassengerList(order.passengers);
    let passenger = [];
    passengers.forEach(passengerItem => passenger.push({
      name: passengerItem.name
    }));
    const infoData = {
      flight,
      passenger,
      typeCancel: "totalCancel"
    };
    this.setState({
      infoData: infoData
    });
    if (order.order.paymentMethod === "transfer") {
      return this.toggleBankDataModal();
    }
    return this.togglePasswordModal();
  }

  render = () => {
    const { order } =  this.props;
    let maxmilhasText = null;
    let airlineText = null;
    if (!order.cancellationData || order.order.status === 'CHANGE_BY_CIA') {
      return null;
    }
    if (order.cancellationData.labels) {
      maxmilhasText = order.cancellationData.labels.details.maxmilhas;
      airlineText = order.cancellationData.labels.details.airline;
    }
    const value = order.cancellationData.billing.purchaseValue;
    const chargeback = order.cancellationData.billing.chargebackValue;
    return (
      <React.Fragment>
        {/* <h1 className={`subtitle ${css`${h1TitlePadding}`}`}>Cancele agora</h1> */}
        <Card
          title='Cancelamento com reembolso'
          selfOpenControl
          type='accordion'
        >
          <p>
            Para solicitar o reembolso da sua viagem, serão cobradas as taxas abaixo, <strong>de acordo com as regras da sua tarifa.</strong>            
          </p>
          <p>
          Após confirmar essa solicitação, vamos enviá-la para avaliação da companhia. Por isso, atenção! Este é um <strong>processo irreversível</strong> e, assim que solicitado, não será possível converter o valor em crédito para uso imediato em uma nova viagem.
          </p>        
          <Summary id="summary-cancel" className={css`margin: ${gridGutter}px -${gridGutter}px;`}>
            <SummaryItem
              title="Valor pago"
              value={convertToReal(value)} />
            {order.order.billing.total_credit > 0 ?
              <SummaryItem
                title="Valor do crédito utilizado"
                value={convertToReal(order.order.billing.total_credit)} /> : ''}
            <SummaryItem
              title="Valor cobrado pela companhia"
              description={airlineText}
              value={convertToReal(order.cancellationData.billing.airline_fee)} />
            <SummaryItem
              title="Valor cobrado pela MaxMilhas"
              description={maxmilhasText}
              value={convertToReal(order.cancellationData.billing.mm_fee)} />
            <SummaryItem
              title="Valor a ser reembolsado (em até 12 meses)"
              value={convertToReal(order.cancellationData.billing.chargebackValue)}
              className={css`background-color: ${(chargeback > 0) ? blue : grayFont}; color: white`} />
          </Summary>
          <div className="row">
            <div className="col-md-10">
              {order.cancellationData.expireIn && (
                
                <strong>
                  Este orçamento é válido até: {moment(order.cancellationData.expireIn).utcOffset('-0300').format('DD/MM/YYYY [às] HH:mm')} (horário de Brasília).
                </strong>
                
              )}
            </div>            
            <div className="col-md-6">              
              <Button
                id="btn_cancel"
                onClick={() => {
                  this.getConfirmationModal()
                }}
                data-action="my-trips-total-cancellation-button"
                outline={0}
                disabled={chargeback <= 0}
                color={chargeback <= 0 ? basicBlack : undefined}
                >                
                {chargeback > 0 ? 'Cancelar com reembolso' : 'Solicitar cancelamento'}
                    </Button>
            </div>
            <br /><br /><br />
            { chargeback > 0 && <div className="col-xs-16 col-md-16">
              <Alert type="warning">
                <strong>Importante!</strong>  Se a companhia alterou ou cancelou o seu voo, vamos conferir se haverá isenção de taxas e os valores acima poderão ser revistos.
              </Alert>
            </div> }
            { chargeback <= 0 && <div className="col-xs-16 col-md-16">
              <Alert type="warning">
                <strong>Importante!</strong> O valor total para o cancelamento deste voo é maior do que o valor pago por você na compra da passagem. Logo, não haverá reembolso. Porém, se a companhia alterou ou cancelou o seu voo, vamos conferir se haverá isenção de taxas e os valores acima poderão ser revistos.
              </Alert>
            </div> }
          </div>
        </Card>

        <div
          className={`cancellation-modal tingle-modal ${
            this.state.messageModalOpen ? "tingle-modal--visible" : ""
            }`}
        >
          <CancellationModal
            open={this.state.messageModalOpen}
            scenario={this.state.messageScenario}
            typeCancel={this.state.infoData.typeCancel}
            closeModal={this.toggleMessageModal}
            btnAction={this.toggleMessageModal}
          />
        </div>

        <PasswordModal
          open={this.state.confirmPasswordModalOpen}
          closeModal={this.togglePasswordModal}
          order={order.order}
          token={order.token}
          onSubmit={this.submit}
        />

        <BankModalData
          open={this.state.bankDataModalOpen}
          closeModal={this.toggleBankDataModal}
          onSubmit={this.bankModalSubmit}
        />
      </React.Fragment>
    );
  }
}